/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import {
  AppBar, Button, Menu, MenuItem, Toolbar, Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProjectDeleteDialog from './components/ProjectDeleteDialog';
import ProjectDialog from './components/ProjectDialog';
import ProjectSelectDialog from './components/ProjectSelectDialog';
import useAuthContext from './auth/useAuthContext';
import LoginForm from './components/LoginForm';
import ProjectSelectEdit from './components/ProjectEdit';

function Layout({
  children, projects, currentProject, setCurrentProject, deleteProject,
}) {
  const { user, logout } = useAuthContext();
  const [updateduser, setUpdateduser] = useState('abc');
  // const { currentProject } = useProjects({ user });
  const [newProjectDialogOpen, setNewProjectDialogOpen] = useState(false);
  const [selectProjectDialogOpen, setSelectProjectDialogOpen] = useState(false);
  const [deleteProjectDialogOpen, setDeleteProjectDialogOpen] = useState(false);
  const [selectProjectEditOpen, setSelectProjectEditOpen] = useState(false);
  const [mainMenuAnchor, setMainMenuAnchor] = useState(null);
  const mainMenuOpen = Boolean(mainMenuAnchor);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const userMenuOpen = Boolean(userMenuAnchor);
  useEffect(() => {
    let timeoutId = null;

    if (user === null) {
      timeoutId = setTimeout(() => {
        setUpdateduser(null);
      }, 500);
    } else {
      clearTimeout(timeoutId);
      setUpdateduser(user);
    }

    return () => clearTimeout(timeoutId);
  }, [user]);

  const handleMenu = (event, menuName) => {
    if (menuName === 'main') {
      setMainMenuAnchor(event.currentTarget);
    } else if (menuName === 'user') {
      setUserMenuAnchor(event.currentTarget);
    }
  };

  const handleMenuClose = (menuName) => {
    if (menuName === 'main') {
      setMainMenuAnchor(null);
    } else if (menuName === 'user') {
      setUserMenuAnchor(null);
    }
  };

  const handleClick = (event) => {
    setMainMenuAnchor(null);
    if (event === 'new') {
      setNewProjectDialogOpen(true);
    } else if (event === 'select') {
      setSelectProjectDialogOpen(true);
    } else if (event === 'delete') {
      setDeleteProjectDialogOpen(true);
    } else if (event === 'edit') {
      setSelectProjectEditOpen(true);
    }
  };

  const handleLogout = () => {
    setUserMenuAnchor(null);
    logout();
  };
  console.log(`User: ${JSON.stringify(user)}`);
  if (!updateduser) {
    return (
      <LoginForm />
    );
  }

  return (
    <div>
      <ProjectDialog open={newProjectDialogOpen} projects={projects} setCurrentProject={setCurrentProject} handleClose={() => setNewProjectDialogOpen(false)} />
      <ProjectSelectDialog
        open={selectProjectDialogOpen}
        handleClose={() => setSelectProjectDialogOpen(false)}
        projects={projects}
        currentProject={currentProject}
        setCurrentProject={setCurrentProject}
      />
      <ProjectDeleteDialog
        open={deleteProjectDialogOpen}
        handleClose={() => setDeleteProjectDialogOpen(false)}
        projects={projects}
        currentProject={currentProject}
        setCurrentProject={setCurrentProject}
        deleteProject={deleteProject}
      />
      <ProjectSelectEdit
        open={selectProjectEditOpen}
        handleClose={() => setSelectProjectEditOpen(false)}
        projects={projects}
        currentProject={currentProject}
        setCurrentProject={setCurrentProject}
      />
      <AppBar position='static' sx={{ mb: 2 }}>
        <Toolbar>
          <Button
            id='main-menu-button'
            variant='contained'
            startIcon={<MenuIcon />}
            onClick={(event) => handleMenu(event, 'main')}
          >
            Menu
          </Button>
          <Menu
            id='main-menu'
            anchorEl={mainMenuAnchor}
            open={mainMenuOpen}
            onClose={() => handleMenuClose('main')}
            MenuListProps={{
              'aria-labelledby': 'main-menu-button',
            }}
          >
            <MenuItem onClick={() => handleClick('new')}>New Project</MenuItem>
            <MenuItem onClick={() => handleClick('select')}>Select Project</MenuItem>
            <MenuItem onClick={() => handleClick('edit')}>Edit project</MenuItem>
            <MenuItem onClick={() => handleClick('delete')}>Delete Project</MenuItem>
          </Menu>
          <Typography
            variant='h6'
            noWrap
            component='div'
            sx={{ ml: 2, flexGrow: 1 }}
          >
            {currentProject}
          </Typography>
          &nbsp;
          <Button
            id='user-menu-button'
            variant='contained'
            sx={{ textTransform: 'none' }}
            startIcon={<ExpandMoreIcon />}
            onClick={(event) => handleMenu(event, 'user')}
          >
            {user}
          </Button>
          <Menu
            id='user-menu'
            anchorEl={userMenuAnchor}
            open={userMenuOpen}
            onClose={() => handleMenuClose('user')}
            MenuListProps={{
              'aria-labelledby': 'user-menu-button',
            }}
          >
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {children}
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      project: PropTypes.string,
      user: PropTypes.string,
      description: PropTypes.string,
      languages: PropTypes.arrayOf(PropTypes.object),
    }),
  ),
  currentProject: PropTypes.string,
  setCurrentProject: PropTypes.func,
  deleteProject: PropTypes.func,
};

Layout.defaultProps = {
  children: <div />,
  projects: [],
  currentProject: '',
  setCurrentProject: () => {},
  deleteProject: () => {},
};

export default Layout;
